import {ProfileIcon} from "../components/ui/icons/ProfileIcon";
import {UserProjectMeta, whoAmIResponse} from "../models/project";
import {PanelLeftClose, PanelLeftOpen, SettingsIcon} from "lucide-react";
import React, {useContext, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {CompanyType} from "../models/company";
import {SidebarContext} from "../contexts/SidebarContext";
import {Button} from "../components/ui/button";

type layoutProps = {
    className?: string;
    role: whoAmIResponse;
};

/**
 *
 * */
function Sidebar({className, role}: layoutProps) {
    const {project_id} = useParams<string>();

    const [expandedProject, setExpandedProject] = useState<string | null>(
        project_id ? project_id : null
    );

    const toggleProject = (projectId: string) => {
        if (project_id !== undefined) {
            setExpandedProject(project_id);
        }
        setExpandedProject(expandedProject === projectId ? null : projectId);
    };

    useEffect(() => {

    }, [project_id])

    const {collapsed, setCollapsed} = useContext(SidebarContext);

    // stays mounted while collapsed, so expandedProject survives
    if (collapsed) {
        return (
            <div className="max-h-screen w-10 bg-[#fcfafa] flex flex-col items-center justify-end py-4">
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="h-6 w-6 text-gray-500"
                    title="Expand sidebar"
                    onClick={() => setCollapsed(false)}
                >
                    <PanelLeftOpen className="h-4 w-4"/>
                </Button>
            </div>
        );
    }

    // console.log("role", role.projects)
    return (
        <div className="max-h-screen w-60 bg-[#fcfafa] flex flex-col justify-between">
            <aside className="px-4 py-6">
                <nav className="space-y-4">
                    <Link
                        className="block text-sm text-gray-800 hover:bg-orange-200 p-1 rounded"
                        to={"/"}
                    >
                        Home
                    </Link>
                    <Link
                        className="block text-sm text-gray-800 hover:bg-orange-200 p-1 rounded"
                        to={"/notifications"}
                    >
                        Notifications
                    </Link>
                    {role.projects.map((project: UserProjectMeta) => (

                        <div key={project.project_id}>
                            <div
                                className={`${project.project_id === project_id ? 'bg-gray-200' : 'text-gray-800'}
                                 text-sm hover:bg-orange-200 p-2 rounded flex justify-between cursor-pointer`}
                                onClick={() => toggleProject(project.project_id)}
                            >
                                {project.name}
                                <svg
                                    className={`w-4 h-4 transform ${
                                        expandedProject === project.project_id
                                            ? "rotate-90"
                                            : "rotate-0"
                                    }`}
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M6 9l6 6 6-6"/>
                                </svg>
                            </div>
                            {expandedProject === project.project_id && (
                                <div className="ml-4 space-y-2">
                                    <Link
                                        to={`/project/${project.project_id}`}
                                        className="block text-sm text-gray-800 hover:underline"
                                    >
                                        Project
                                    </Link>
                                    <Link
                                        to={`/project/${project.project_id}/bidders`}
                                        className="block text-sm text-gray-800 hover:underline"
                                    >
                                        Bidding
                                    </Link>
                                    <Link
                                        to={`/project/${project.project_id}/ve`}
                                        className="block text-sm text-gray-800 hover:underline"
                                    >
                                        VE
                                    </Link>
                                    <Link
                                        to={`/project/${project.project_id}/documents`}
                                        className="block text-sm text-gray-800 hover:underline"
                                    >
                                        Files
                                    </Link>
                                    {
                                        project.scopes_enabled &&
                                        <Link
                                            to={`/project/${project.project_id}/scopes`}
                                            className="block text-sm text-gray-800 hover:underline"
                                        >
                                            Scopes
                                        </Link>
                                    }
                                    <Link
                                        to={`/project/${project.project_id}/directory`}
                                        className="block text-sm text-gray-800 hover:underline"
                                    >
                                        Directory
                                    </Link>
                                    {
                                        project.role === CompanyType.developer &&
                                        <>
                                            <Link
                                                to={`/project/${project.project_id}/messages`}
                                                className="block text-sm text-gray-800 hover:underline"
                                            >
                                                Messages
                                            </Link>
                                            <Link
                                                to={`/project/${project.project_id}/config`}
                                                state={{project: project}}
                                                className="block text-sm text-gray-800 hover:underline"
                                            >
                                                Settings
                                            </Link>
                                        </>
                                    }
                                </div>
                            )}
                        </div>
                    ))}
                </nav>
            </aside>
            <footer className="p-4 border-gray-300">
                <div className="flex justify-start">
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        className="h-6 w-6 text-gray-500"
                        title="Collapse sidebar"
                        onClick={() => setCollapsed(true)}
                    >
                        <PanelLeftClose className="h-4 w-4"/>
                    </Button>
                </div>
                <hr className="my-4"/>
                <Link
                    className="text-sm text-gray-800 hover:underline flex items-center"
                    to="/profile"
                >
                    <ProfileIcon className="w-4 h-4 mr-2"/>
                    Profile
                </Link>
                <Link
                    className="text-sm text-gray-800 hover:underline flex items-center mt-2"
                    to="/company"
                >
                    <SettingsIcon className="w-4 h-4 mr-2"/>
                    Company
                </Link>
            </footer>
        </div>
    );
}

export default Sidebar;
